// DS: DEV8
import React from 'react';
import c from 'classnames';
import DeviationDumbView from '../DeviationViews/Dumbo';
import s from './GallectionCoverDumbo.scss';
var GallectionCoverDumbo = function (_a) {
    var width = _a.width, height = _a.height, className = _a.className, thumb = _a.gallection.thumb, placeholder = _a.placeholder, placeholderClassName = _a.placeholderClassName;
    if (!thumb) {
        return (React.createElement("div", { className: c(className, placeholderClassName || s['no-image']), style: { width: width, height: height } }, placeholder));
    }
    return (React.createElement(DeviationDumbView, { className: className, width: width, height: height, deviation: thumb }));
};
GallectionCoverDumbo.displayName = 'GallectionCoverDumbo';
export default GallectionCoverDumbo;
//# sourceMappingURL=GallectionCoverDumbo.js.map